import { DashboardMutations } from './partials/dashboard'
import { DocketEntryEditMutations } from './partials/docket-entry-edit'
import { PrintMutations } from './partials/print'
import { UploadLinksMutations } from './partials/upload-links'

export const DocketEntryMutations = {
  ...DashboardMutations,
  ...DocketEntryEditMutations,
  ...PrintMutations,
  ...UploadLinksMutations,

  setDocketEntry: (state, payload) => { state.docketEntry = payload },
  setDocketEntryType: (state, payload) => { state.docketEntryType = payload },
  setTasksAssignees: (state, payload) => { state.tasksData.assignees = payload },
}
